import styled, { css, keyframes } from 'styled-components';

import type { FlyingElementSrc } from '../types';

export const move = keyframes`
    0% {
      transform: translateY(0) rotateY(0);
    }

    50% {
      transform: translateY(15px) rotateY(24deg);
    }

    100% {
      transform: translateY(0) rotateY(0);
    }
`;

interface ScFlyingElementProps extends FlyingElementSrc {
  delay: number;
  mediaQuery?: string;
}

export const ScFlyingElement = styled.img<ScFlyingElementProps>`
  position: absolute;
  top: ${({ posY }) => posY}%;
  left: ${({ posX }) => posX}%;
  transform: translate(-50%, -50%);
  z-index: ${({ index }) => index || 5};

  ${({ size }) =>
    size &&
    css`
      width: ${size}px;
      aspect-ratio: 1 / 1;
    `}
  animation: ${move} infinite ${({ delay }) => delay}s ease-in-out;

  @media (max-width: ${({ mediaQuery }) => mediaQuery || '600px'}) {
    top: ${({ posYMob }) => posYMob}%;
    left: ${({ posXMob }) => posXMob}%;
    zoom: 0.7;

    ${({ sizeMob }) =>
      sizeMob &&
      css`
        width: ${sizeMob}px;
        aspect-ratio: 1 / 1;
      `}
  }
`;
